import { render } from "./UploadCnh.vue?vue&type=template&id=7dcfe06b"
import script from "./UploadCnh.vue?vue&type=script&lang=js"
export * from "./UploadCnh.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__